import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/course-year';
const backUrl='/department'+Url;
const courseUrl='/getallcourse';


class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            year_name:'', 
            course_id:'',
            courseData:[],
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){
        viewData(courseUrl).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({courseData:datam});
                if(this.props.match.params.id){
                    viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                        if(res.data.status===200){
                            let data=res.data.data;
                            this.setState({
                                year_name:data.year_name?data.year_name:'', 
                                course_id:data.course_id?data.course_id:'', 
                                preloader:false, 
                            });
                        }
                    });
                }
            }
        });
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let params={
                year_name:this.state.year_name,
                course_id:this.state.course_id,
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,year_name,course_id,courseData} = this.state;
        let role=permissionCheck('course-year',title);
        if(!role)
            return <Nopermission/>;
        const year_nameValid= this.validator.message('Course Year',year_name, 'required');
        const course_idValid= this.validator.message('Course',course_id, 'required');
        return (
            <div id="page_content_inner" className="uk-width-medium-4-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{title} Course Year</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${year_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Course Year<span className="req">*</span></label>
                                    <input type="text" name="year_name" value={year_name} onChange={this.setStateFromInput} className={ `md-input ${year_nameValid ?'md-input-danger':''}`} /> 
                                    {year_nameValid} 
                                </div>
                            </div>
  
                            <div className={ `md-input-wrapper ${course_id ? 'md-input-filled' : ''}`}>
                                <select id="select_demo_1" className="md-input" name="course_id" onChange={this.setStateFromInput} value={course_id}>
                                    <option value="">Select Course</option>
                                    {
                                        courseData && courseData.map((val,i)=>{
                                            return(
                                                <option key={i} value={val.course_id} >{val.course_name}</option>
                                            );
                                        })
                                    } 
                                </select> 
                                {course_idValid} 
                            </div>
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1">
                                <Link to={backUrl} className="md-btn md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Department/CourseYear/addEdit.js